var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticStyle:{"padding-top":"12px"}},[_c('subHeader')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }